module.exports = __webpack_public_path__ + "static/media/96 - Faux Real - Boss Sweet.00c9cba4.mp3";